import './ProjectAdmin.css';
import CloseSave from '../design/close';
import { GetCsvFileAdminGrop } from '../../faetures/fetch';
import SendFile from './ContinerSendFile';
import TableProjectAdmin from './TableProjectAdmin';
import { fetchGetAdminProject } from '../../faetures/fetch';
import { useEffect, useState } from 'react';
import InsertMassage from './InsertMassage';


export default function ProjectAdmin ({onClose}) {
    const [names, setNames] = useState([]);
    const [massage, setMassage] = useState({open: false, data: {}});
    
    useEffect(() => {
        fetchGetAdminProject('start-project').then((resolve) => {
            if (resolve) {
                setNames(resolve);
            }})
    }, [])

    const insertNamesToServer = (resolve) => {
        if (typeof resolve === 'object' && resolve !== null) {
            setMassage({open: true, data: resolve['response']});
            setNames(JSON.parse(resolve['projects']));
        }
    }

    const insertResolveToMassage = (resolve) => {
        setMassage({open: true, data: resolve});
    }

    return (<>
        <div className="grop-admin-setting main-docket">
            <div>
                <p> grop admin </p>
                <CloseSave setClose={() => onClose()} />
            </div>

            <div className='grop-admin-setting-head'>
                <p> רשימת פרוייקטים </p>
                <div>
                    <p onClick={() => GetCsvFileAdminGrop('projects.csv')}> הורדה קובץ רשימת פרוייקטים </p>
                    <SendFile p={true} send_file={insertNamesToServer} />
                </div>
            </div>

            <div className='grop-admin-insert-files'>
                <p>עדכן טיסות</p>
                <SendFile className={'grop-admin-setting-send-file-table'} send_file={insertResolveToMassage} />
                <p>עדכון נסיעות פנים</p>
                <SendFile className={'grop-admin-setting-send-file-table'} send_file={insertResolveToMassage} />
            </div>
            
            <TableProjectAdmin names={names} />

            {
                massage.open && <InsertMassage setClose={() => setMassage({open: false, data: {}})} data={massage.data} />
            }

        </div>
    </>)
}